"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FbApiRole = void 0;
var FbApiRole;
(function (FbApiRole) {
    FbApiRole["Admin"] = "Admin";
    FbApiRole["Editor"] = "Editor";
    FbApiRole["Moderator"] = "Moderator";
    FbApiRole["Advertiser"] = "Advertiser";
    FbApiRole["Analyst"] = "Analyst";
    FbApiRole["Unknown"] = "Unknown"; // the default role in case the response from FB api isn't successfully parsed
})(FbApiRole = exports.FbApiRole || (exports.FbApiRole = {}));
//# sourceMappingURL=fbApiRole.enum.js.map